import { injectable } from "tsyringe";
import { OperationalApiRepository } from "@/app/infrastructures/repositories/api/OperationalAreaApiRepository";
import {
  UrsaCodeList,
  UrsaCodeListRequest
} from "@/domain/entities/OperationalArea";

@injectable()
export class OperationalAreaPresenter {
  private repository: OperationalApiRepository;

  constructor(repository: OperationalApiRepository) {
    this.repository = repository;
  }

  public getUrsaCodeList(params: UrsaCodeListRequest): Promise<UrsaCodeList> {
    return this.repository.getUrsaCodeList(params);
  }

  getUrsaDetail(ursaCode: string) {
    return this.repository.getUrsaDetail(ursaCode);
  }

  updateUrsaStatus(ursaCode: string, status: boolean) {
    return this.repository.updateUrsaStatus(ursaCode, status);
  }
}
